import CheckPermission from '../../../hooks/CheckPermission';
import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { Formik, Form, Field } from 'formik'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from 'primereact/checkbox'
import CustomButton from '../../../shared/CustomButton'
import toast from 'react-hot-toast'

const wardOptions = ['Ward A', 'Ward B', 'Ward C']
const bedOptions = ['Bed 1', 'Bed 2', 'Bed 3']
const dischargeReasonOptions = [
  {
    label: 'Medically Fit for Discharge',
    value: 'Medically Fit for Discharge'
  },
  { label: 'Against Medical Advice', value: 'Against Medical Advice' },
  {
    label: 'Transfered to another facility',
    value: 'Transfered to another facility'
  }
]

const initialForm = {
  dischargeDate: '',
  admissionDate: '',
  dischargeReason: '',
  admissionReason: '',
  clinicalNarrative: '',
  investigation: '',
  recommendation: '',
  dischargeInstruction: '',
  dischargeDestination: '',
  supportSystem: '',
  signature: '',
  infective: false,
  mobilityAssistance: false,
  fallRisk: false,
  covid19: false,
  confused: false,
  ward: '',
  bed: ''
}

const DischargeTab = ({ patient }) => {
  const { hasPermission } = CheckPermission();
  const [showAddPatient, setShowAddPatient] = useState(false)

  const handleSubmit = (values, { resetForm }) => {
    if (!hasPermission('dischargePatient', 'create')) return;
    const payload = {
      ...values,
      patient: patient?.patient_id
    }
    console.log('====================================')
    console.log(payload)
    console.log('====================================')
    toast.success('Patient discharged successfully!')
    resetForm()
  }

  return (
    <div className='h-full flex flex-col'>
      <div className='p-6 pb-4 flex-shrink-0'>
        <h2 className='text-2xl font-bold'>Patient Discharge</h2>
      </div>
      <div className='flex-1 px-6 pb-6 overflow-y-auto'>
        <div className='bg-gray-50 rounded-lg p-6 h-[calc(100vh-250px)] overflow-y-auto'>
          <h3 className='text-lg font-semibold text-gray-800 mb-6'>
            Discharge Information Form
          </h3>
          <Formik
            initialValues={initialForm}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ values, setFieldValue, resetForm, submitForm }) => (
              <Form className='space-y-6'>
                {/* Row 1: Patient, Date of Discharge, Date of Admission */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                  {/* <div className="flex items-center gap-2">
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Patient
                      </label>
                      <InputText
                        value={patient?.name || ""}
                        className="w-full bg-gray-100"
                        disabled
                      />
                    </div>
                    <CustomButton
                      type="button"
                      icon={<FaPlus className="text-blue-600" />}
                      className="ml-2 p-button-sm p-button-info"
                      onClick={() => setShowAddPatient(true)}
                      tooltip="Add Patient"
                    />
                  </div> */}
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Date of Discharge
                    </label>
                    <Field name='dischargeDate'>
                      {({ field }) => (
                        <InputText
                          {...field}
                          type='date'
                          className='w-full'
                          required
                        />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Date of Admission
                    </label>
                    <Field name='admissionDate'>
                      {({ field }) => (
                        <InputText
                          {...field}
                          type='date'
                          className='w-full'
                          required
                        />
                      )}
                    </Field>
                  </div>
                </div>
                {/* Row 2: Reason for Discharge, Reason for Admission, Clinical Narrative */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Reason for Discharge
                    </label>
                    <Dropdown
                      name='dischargeReason'
                      value={values.dischargeReason}
                      options={dischargeReasonOptions}
                      onChange={e => setFieldValue('dischargeReason', e.value)}
                      placeholder='Select Reason'
                      className='w-full'
                      required
                    />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Reason for Admission
                    </label>
                    <Field name='admissionReason'>
                      {({ field }) => (
                        <InputTextarea {...field} rows={2} className='w-full' />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Clinical Narrative
                    </label>
                    <Field name='clinicalNarrative'>
                      {({ field }) => (
                        <InputTextarea {...field} rows={2} className='w-full' />
                      )}
                    </Field>
                  </div>
                </div>
                {/* Row 3: Relevant Investigation, Recommendation, Discharge Instruction */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Relevant Investigation
                    </label>
                    <Field name='investigation'>
                      {({ field }) => (
                        <InputTextarea {...field} rows={2} className='w-full' />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Recommendation
                    </label>
                    <Field name='recommendation'>
                      {({ field }) => (
                        <InputTextarea {...field} rows={2} className='w-full' />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Discharge Instruction
                    </label>
                    <Field name='dischargeInstruction'>
                      {({ field }) => (
                        <InputTextarea {...field} rows={2} className='w-full' />
                      )}
                    </Field>
                  </div>
                </div>
                {/* Row 4: Discharge Destination, Support System, Signature */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Discharge Destination
                    </label>
                    <Field name='dischargeDestination'>
                      {({ field }) => (
                        <InputText {...field} className='w-full' />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Support System
                    </label>
                    <Field name='supportSystem'>
                      {({ field }) => (
                        <InputText {...field} className='w-full' />
                      )}
                    </Field>
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Signature
                    </label>
                    <div className='w-full h-20 border rounded bg-gray-50 flex items-center justify-center text-gray-400'>
                      Sign here (not implemented)
                    </div>
                  </div>
                </div>
                {/* Row 5: Checkboxes */}
                <div>
                  <h4 className='text-md font-semibold text-gray-800 mb-4'>
                    Additional Information
                  </h4>
                  <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4'>
                    {Object.entries({
                      infective: 'Infective',
                      mobilityAssistance: 'Mobility Assistance',
                      fallRisk: 'Fall Risk',
                      covid19: 'Covid 19',
                      confused: 'Confused'
                    }).map(([name, label]) => (
                      <div key={name} className='flex items-center gap-2'>
                        <Checkbox
                          inputId={name}
                          name={name}
                          checked={values[name]}
                          onChange={e => setFieldValue(name, e.checked)}
                        />
                        <label htmlFor={name}>{label}</label>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Row 6: Select Ward, Select Bed */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Select Ward
                    </label>
                    <Dropdown
                      name='ward'
                      value={values.ward}
                      options={wardOptions.map(w => ({ label: w, value: w }))}
                      onChange={e => setFieldValue('ward', e.value)}
                      placeholder='Select Ward'
                      className='w-full'
                    />
                  </div>
                  <div>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Select Bed
                    </label>
                    <Dropdown
                      name='bed'
                      value={values.bed}
                      options={bedOptions.map(b => ({ label: b, value: b }))}
                      onChange={e => setFieldValue('bed', e.value)}
                      placeholder='Select Bed'
                      className='w-full'
                    />
                  </div>
                </div>
                {/* Action Buttons */}
                <div className='flex justify-end gap-3 pt-4 border-t border-gray-200'>
                  <CustomButton
                    type='button'
                    label='Cancel'
                    className='p-button-secondary'
                    onClick={() => resetForm()}
                  />
                  {hasPermission('dischargePatient', 'create') && (
                    <CustomButton
                    type='submit'
                    label='Save'
                    className='p-button-primary'
                    onClick={submitForm}
                  />
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {/* Add Patient Dialog (dummy, reuse actual dialog in real app) */}
      {showAddPatient && (
        <div className='fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50'>
          <div className='bg-white p-6 rounded shadow-lg w-96'>
            <h3 className='text-lg font-bold mb-2'>Add Patient</h3>
            <p className='mb-4 text-gray-600'>
              (Dialog placeholder. Reuse AddPatientDialog from ward management.)
            </p>
            <CustomButton
              className='p-button-primary'
              label='Close'
              onClick={() => setShowAddPatient(false)}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default DischargeTab
